export const channelConstants = {
	ChannelSaveRequest: "CHANNEL_SAVE_STARTED",
	ChannelSaveSuccess: "CHANNEL_SAVE_COMPLETED",
	ChannelSaveFailure: "CHANNEL_SAVE_FAILED",

	ChannelGetByfilterRequest: "CHANNEL_GET_BYFILTER_STARTED",
	ChannelGetByfilterSuccess: "CHANNEL_GET_BYFILTER_COMPLETED",
	ChannelGetByfilterFailure: "CHANNEL_GET_BYFILTER_FAILED",

	ChannelGetAllRequest: "CHANNEL_GET_ALL_STARTED",
	ChannelGetAllSuccess: "CHANNEL_GET_ALL_COMPLETED",
	ChannelGetAllFailure: "CHANNEL_GET_ALL_FAILED",

	ChannelDetailRequest: "CHANNEL_GET_DETAIL_STARTED",
	ChannelDetailSuccess: "CHANNEL_GET_DETAIL_COMPLETED",
	ChannelDetailFailure: "CHANNEL_GET_DETAIL_FAILED",

	ChannelDeleteRequest: "CHANNEL_DELETE_STARTED",
	ChannelDeleteSuccess: "CHANNEL_DELETE_COMPLETED",
	ChannelDeleteFailure: "CHANNEL_DELETE_FAILED",

	ChannelFaviruteRequest: "CHANNEL_GET_FAVOURITE_STARTED",
	ChannelFaviruteSuccess: "CHANNEL_GET_FAVOURITE_COMPLETED",
	ChannelFaviruteFailure: "CHANNEL_GET_FAVOURITE_FAILED",

	ChannelnonFaviruteRequest: "CHANNEL_GET_NON_FAVOURITE_STARTED",
	ChannelnonFaviruteSuccess: "CHANNEL_GET_NON_FAVOURITE_COMPLETED",
	ChannelnonFaviruteFailure: "CHANNEL_GET_NON_FAVOURITE_FAILED"
}